<ng-container *ngIf="component.data$ | async as data">
  <py-header-navigation-item
    *ngIf="data.name"
    [class.d-none]="!(isAnonymous$ | async)"
    [url]="{ cxRoute: 'login' } | cxUrl"
    [disableActive]="hasActiveMenuItem$ | async"
  >
    <i nz-icon nzType="login" nzTheme="outline"></i>
    <span class="ml-1 text-nowrap">{{ 'navigation.signIn_title' | cxTranslate }}</span>
  </py-header-navigation-item>
</ng-container>
